import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

import { injectIntl } from 'components';

const styles = theme => ({
  dialog: {
    maxWidth: 'none',
    width: '100%',
  },
  dialogPaper: {
    width: '100%',
    [theme.breakpoints.down('xs')]: {
      margin: '0px !important',
    },
  },
  dialogTitle: {
    padding: '10px 0px 0px 0px',
  },
  closeButton: {
    position: 'absolute',
    top: 10,
    right: 10,
  },
  dialogContent: {
    padding: '0 !important',
  },
});

const SmartDialog = ({
  children,
  classes,
  maxWidth,
  onClose,
  open,
  title,
  closeButtonOnTop,
  noFrame,
  noOutsideClick,
}) => (
  <Dialog
    classes={{
      paper: classes.dialogPaper,
      root: classes.dialog,
    }}
    fullWidth
    maxWidth={maxWidth}
    onClose={noOutsideClick ? noop : onClose}
    open={open}
    scroll="body"
  >
    {!noFrame && (
      <DialogTitle classes={title === '' ? { root: classes.dialogTitle } : null}>
        {title}
      </DialogTitle>
    )}
    {closeButtonOnTop && (
      <IconButton
        aria-label="Close"
        className={classes.closeButton}
        onClick={onClose}
      >
        <CloseIcon />
      </IconButton>
    )}
    <DialogContent classes={{ root: `smart-dialog ${noFrame && classes.dialogContent}` }}>
      {children}
    </DialogContent>
  </Dialog>
);

SmartDialog.propTypes = {
  children: PropTypes.node.isRequired,
  classes: PropTypes.shape({}).isRequired,
  maxWidth: PropTypes.oneOf([
    'xs', 'sm', 'md', 'lg', 'xl', false,
  ]),
  open: PropTypes.bool,
  title: PropTypes.node,
  closeButtonOnTop: PropTypes.bool,
  noFrame: PropTypes.bool,
  noOutsideClick: PropTypes.bool,

  onClose: PropTypes.func.isRequired,
};

SmartDialog.defaultProps = {
  maxWidth: 'sm',
  open: false,
  closeButtonOnTop: false,
  title: null,
  noFrame: false,
  noOutsideClick: false,
};

const wrappedSmartDialog = withStyles(styles)(injectIntl(SmartDialog));
wrappedSmartDialog.displayName = 'SmartDialog';

export default wrappedSmartDialog;
